<template>
  <el-drawer :visible.sync="value" :with-header="false" v-bind="$attrs" v-on="$listeners" :before-close="beforeClose" :modal-append-to-body='false'>
    <div class="micro-header">
      <img class="close" src="~_img/common/drawer-close.png" alt="" @click="close"/>
      <div class="drawer-title">
        <img src="~_img/common/drawer-head-icon.png" alt="" />
        <span>{{ title }}</span>
      </div>
      <div class="tip">{{tipText}}</div>
    </div>
    <slot></slot>
  </el-drawer>
</template>

<script>
export default {
  name: "x-drawer",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    tipText:String
  },
  data() {
    return {}
  },
  methods: {
    // 使用子传父的方式关闭弹框
    beforeClose(done) {
      this.$emit("input", false)
      this.$emit('close')
    },
    close(){
      this.$emit("input", false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.el-drawer {
  .micro-header {
    display: flex;
    align-items: center;
    margin: 18px 0 14px;
    .close {
      width: 28px;
      margin-right: 16px;
      cursor: pointer;
    }
    .drawer-title {
      display: flex;
      align-items: center;
      img {
        width: 19px;
      }
      span {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-left: 10px;
      }
    }
    .tip{
      font-size: 14px;
font-weight: 600;
color: #BBBBBB;
margin-left: 20px;
    }
  }
}
</style>
